"use client"

import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import MessageHelper from '@utils/messageHelper'
import useT from '@hooks/useTranslation'
import useRedirect from '@hooks/useRedirectBack'
import STATUSES from 'db/models/partials/constants/trackingOfferStatuses'
import { useSearchParamsAsQuery } from '@hooks/useSearchParamsAsQuery'

export default function OfferActiveStateGuard ({ offer }) {
    const [redirect] = useRedirect()
    const [redirectPath, setRedirectPath] = useState('')
    const pathname = usePathname()
    const query = useSearchParamsAsQuery()
    const zawieszone = useT('Ogłoszenie jest czasowo zawieszone')

    useEffect(() => {
        if (!redirectPath) {
            const hangedOrPendingBuyout = (offer?.tracking?.hanged
                || offer?.tracking?.status?.value === STATUSES.pendingBuyout)

            if (!hangedOrPendingBuyout) return

            MessageHelper.message(zawieszone + '.')

            const isDostawczaki = query.d == '1'
            if (isDostawczaki) {
                window.location.replace(toDostawczaki(pathname))
            } else {
                setRedirectPath('/')
            }
        }
    }, [offer._id, pathname, query])

    return redirectPath
        ? redirect(redirectPath)
        : null
}

const PATH_DIFFERENCES = {
    '/dostawcze': '/samochody-dostawcze',
    '/czesci': '/czesci-auta-dostawcze',
    '/serwisy-samochodowe-uslugi': '/serwis-aut-dostawczych',
    '/narzedzia-warsztatowe-sprzedaz': '/narzedzia-warsztatowe-wyposazenie',
    '/wynajem-samochodow-oferty': '/wynajem',
}

function toDostawczaki (path, address = 'https://dostawczaki.pl', differences = PATH_DIFFERENCES) {
    let _path = path
    for (const key in differences) {
        _path = _path.replace(key, differences[key])
    }
    return address + _path
}